import {useNavigate, useParams} from "react-router-dom";
import {PageHeader} from "../../../components/PageHeader";
import React, {useEffect, useMemo, useState} from "react";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import Th_title from "../../../components/Th_title";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import {useDispatch, useSelector} from "react-redux";
import {ContentCategory, ContentStatus} from "../../../constant/CodeSpecNum";
import {getDailyCheckReport} from "../../../api/evaluation/DailyCheckReportService";
import {skeleton} from "../../../redux/slice/apiSlice";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {changeProgressStatusValue, changeStatusNumericValue} from "../../../redux/slice/contentSlice";
import SignContainer from "../../../components/basic/SignContainer";
import {
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
    DetailSummaryListButton,
    DetailSummaryPrintButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import {SettingsContentHeroActions} from "../../settings/shared/SettingsContentHeroActions";
import DailyCheckReportItemsPanel from "./DailyCheckReportItemsPanel";

function DailyCheckReportView() {
    const {id} = useParams();

    const [dailyCheckReport, setDailyCheckReport] = useState({});
    const [list, setList] = useState([]);
    const [progress, setProgress] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const statusNumericValue = useSelector(state => state.content.statusNumericValue);

    useEffect(() => {
        if (!id) return;

        setDailyCheckReport({});
        setList([]);
        setProgress(undefined);
        dispatch(skeleton(true));

        Promise.all([
            getDailyCheckReport(id),
            getContentStatus({contentId: id, contentCategory: ContentCategory.DAILY_CHECK_REPORT}),
        ]).then(([dailyCheck, progressResponse]) => {
            if (dailyCheck.status === 201) {
                if (dailyCheck.data.errorCode === "AUTHORITY") {
                    alert(dailyCheck.data.reason);
                    navigate(-1);
                }
            }

            setDailyCheckReport(dailyCheck.data);
            setList(dailyCheck.data.children ?? []);
            setProgress(progressResponse.data);

            if (progressResponse?.status === 200) {
                dispatch(changeStatusNumericValue(progressResponse.data.statusNumericValue));
                dispatch(changeProgressStatusValue(progressResponse.data));
            }
        }).finally(() => dispatch(skeleton(false)));
    }, [id, dispatch, navigate]);

    const canMoveToUpdate =
        dailyCheckReport.auth?.update &&
        progress?.statusNumericValue !== ContentStatus.COMPLETE.statusNumericValue;

    const headerActions = (
        <SettingsContentHeroActions>
            <DetailSummaryPrintButton/>
            {canMoveToUpdate ? (
                <DetailSummaryButton onClick={() => navigate(`/evaluation/dailyCheck/update/${id}`)}>
                    수정
                </DetailSummaryButton>
            ) : null}
            <DetailSummaryListButton url="/evaluation/dailyCheck">목록</DetailSummaryListButton>
        </SettingsContentHeroActions>
    );

    const itemsPanelTitle = useMemo(
        () => dailyCheckReport.dailyCheck?.name || "체크항목",
        [dailyCheckReport.dailyCheck?.name],
    );

    if (Object.keys(dailyCheckReport).length === 0) {
        return null;
    }

    return (
        <div className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout flex min-h-0 flex-1 flex-col">
            <PageHeader
                header="일일체크현황"
                indicator="평가관리/보고서 > 업무보고서 > 일일체크현황 > 상세"
                headerActions={headerActions}
            />

            <DetailListPage className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-auto">
                    <DetailPanel title="점검내용">
                        <DetailKvTable>
                            <tbody>
                            <tr>
                                <Th_title title="등록일" colspan={1} className="fieldset-td">
                                    <ReadOnlyInputBasic target="createdAt" value={dailyCheckReport.createdAt}/>
                                </Th_title>
                                <Th_title title="등록자" colspan={1} className="fieldset-td">
                                    <ReadOnlyInputBasic target="createdBy" value={dailyCheckReport.createdBy?.name}/>
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title="수정일" colspan={1} className="fieldset-td">
                                    <ReadOnlyInputBasic target="updatedAt" value={dailyCheckReport.updatedAt}/>
                                </Th_title>
                                <Th_title title="수정자" colspan={1} className="fieldset-td">
                                    <ReadOnlyInputBasic target="updatedBy" value={dailyCheckReport.updatedBy?.name}/>
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title="체크일자" colspan={3} className="fieldset-td">
                                    <ReadOnlyInputBasic target="checkDate" value={dailyCheckReport.checkDate}/>
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title="일일체크코드" colspan={3} className="fieldset-td">
                                    <ReadOnlyInputBasic target="dailyCheck" value={dailyCheckReport.dailyCheck?.name}/>
                                </Th_title>
                            </tr>
                            </tbody>
                        </DetailKvTable>
                    </DetailPanel>

                    <DailyCheckReportItemsPanel
                        title={itemsPanelTitle}
                        list={list}
                        mode="view"
                        readOnly
                    />

                    <ApprovalComponent
                        contentId={dailyCheckReport.id}
                        contentCategory={ContentCategory.DAILY_CHECK_REPORT}
                    />

                    <SignContainer
                        contentId={dailyCheckReport.id}
                        contentCategory={ContentCategory.DAILY_CHECK_REPORT}
                        statusNumericValue={statusNumericValue}
                    />
                </div>
            </DetailListPage>
        </div>
    );
}

export {DailyCheckReportView};
